import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const prefersReducedMotion = useReducedMotion();
  return <motion.div className={className} initial={prefersReducedMotion ? false : {
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.42,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-323" data-mp="3gh8p8rxuqm98">
      {children}
    </motion.div>;
}